import { TextField } from "formik-mui";

export const FullWidthField = (props) => <TextField fullWidth {...props} />;
